import CloseIcon from '@mui/icons-material/Close';
import Dummy from '../../../src/assets/images/dummy.png'
import { Row, Col, Button } from 'react-bootstrap'
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setDeviceTypes } from '../../Redux/Actions/DeviceActions';
import { setAreaTypes } from '../../Redux/Actions/AreaActions';
import { setMediaTypes } from '../../Redux/Actions/MediaActions';
import { setGuideTypes } from '../../Redux/Actions/GuideActions';
import { getQrCodeThumbnail } from '../../Redux/Actions/QR';
import { copyAllQRDataById, fetchAllQrCodesWithThumbnail, fetchDeviceProducts, fetchGuideProducts, fetchMediaData, fetchProducts, fetchSitesWithParentCompany } from '../../Redux/Api/fetch.api';
import UploadImage from '../QR/QRUpload';
import { WebcamCapture } from '../QR/WebcamComponent';
import ImageCropper from '../QR/CropImage';
import favoriteIcon from "../../assets/images/favorite_star.png";
import LoginImage from "../../assets/images/login-image.png";
import * as url from "../../api/uri_helper";
import ReactQuillEditor from "../Quill/Quill";
import { Select, Tooltip } from 'antd';
import axios from 'axios';
import { copyQRCodeIdData } from '../../Redux/Actions/CopyQRCode';
import toast, { Toaster } from 'react-hot-toast';
import Loader from '../loader';
import ReactPlayer from 'react-player';
import { useHistory } from 'react-router';
import { useTranslation } from "react-i18next";
const UploadMedia = (props) => {
    const { t } = useTranslation("dashboard");
    const {
        SiteName,
        Id,
        QRCode,
        NewQR,
        SetIsUploadPageShow,
        isUploadPageShow,
        setIsSiteCompanyShow,
        setNewQR,
        setqrcode,
        setValidQrError,
        setLocationIdByQRId,
        CurrentLocationId,
        CurrentCompanyId,
        Data,
        setCompanyName,
        SetIsUploadMediaShow,
        CurrentCompanyLocationId,
        CompanyName,
        CompanyData
    } = props;

    let mediaKey = '';
    const dispatch = useDispatch();
    const history = useHistory();
    const InputRef = useRef();
    const fileInputRef = useRef(null);
    const cropHandledRef = useRef(false);
    const [desc, setDesc] = useState('');
    const [source, setSource] = useState();
    const [showVideo, setShowVideo] = useState();
    const [urlMedia, setUrlMedia] = useState("");
    const [pdfMedia, setPdfMedia] = useState("");
    const [pdferror, setPdfError] = useState("");
    const [textMedia, setTextMedia] = useState("");
    const [countDesc, setCountDesc] = useState(0);
    const [imgSrcs, setImgSrcs] = useState([]);
    const [mediaFiles, setMediaFiles] = useState([]);
    const [captureFiles, setCaptureFiles] = useState([]);
    const [textError, setTextError] = useState(false);
    const [urlFormatError, setUrlFormatError] = useState(false);
    const [videoFormatError, setVideoFormatError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [videoMedia, setVideoMedia] = useState("");
    const [deviceName, setDeviceName] = useState([]);
    const [guideName, setGuideName] = useState([]);
    const [areaName, setAreaName] = useState([]);
    const [siteData, setSiteData] = useState([]);
    const [companyName, setCompanyNames] = useState("");
    const [companyId, setCompanyId] = useState("");
    const [siteName, setSiteName] = useState("");
    const [siteId, setSiteId] = useState("");
    const [dialogOpen, setDialogOpen] = useState(false);
    const [videoMessage, setVideoMessage] = useState(false);
    const [videoFileName, setVideoFileName] = useState("");
    const [pdfFileName, setPDFFileName] = useState("");
    const [searchState, setSearchState] = useState()
    const [currentImage, setCurrentImage] = useState(null);
    const [isWebCamClick, setIsWebCamCLick] = useState(false)
    const [isCaptureImage, setIsCaptureImage] = useState(false)
    const [currentDeviceTypeId, setCurrentDeviceTypeId] = useState();
    const [currentAreaTypeId, setCurrentAreaTypeId] = useState();
    const [currentGuideTypeId, setCurrentGuideTypeId] = useState();
    const [currentMediaTypeId, setCurrentMediaTypeId] = useState();
    const [currentMediaTypeKey, setCurrentMediaTypeKey] = useState();
    const [mediaTypeSelected, setMediaTypeSelected] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [videoSizeError, setVideoSizeError] = useState(false);
    const allDeviceTypes = useSelector((state) => state.allDeviceType.deviceTypes);
    const allAreaTypes = useSelector((state) => state.allAreaType.areaTypes);
    const allGuideTypes = useSelector((state) => state.allGuideType.guideTypes);
    const allMediaTypes = useSelector((state) => state.allMediaType.mediaTypes);
    const allQrDataWithThumbnail = useSelector((state) => state.allQrDataWithThumbnail.qrCodeThumbnailData);
    // const ProductName = allQrDataWithThumbnail.find(x => x.qRcodeId === parseInt(id))
    const [copyQRCodeId, setCopyQRCodeId] = useState(t("SelectQRPlaceholder"));
    const [getRadioButton, setGetRadioButton] = useState({ show: "show", selected: "show", });
    const [error, setError] = useState({
        video: '',
        imagesErr: '',
        urlMediaErr: '',
        pdfMediaErr: '',
        // durationError: '',
        textMediaErr: '',

    })
    const [images, setImages] = useState({
        upload: {
            pictures: [],
            maxFileSize: 53351526,
            imgExtension: [".jpg", ".png", ".jpeg"],
            defaultImages: [
            ]
        }

    })

    useEffect(() => {
        if (dialogOpen) {
            cropHandledRef.current = false;

        }
        setLoading(false);
    }, [dialogOpen]);


    useEffect(() => {
        setTimeout(() => {
            setLoading(false)
        }, 2000)
        getDeviceTypeData();
        getAreaTypeDetails();
        getMediaTypeDetails();
        getGuideTypeDetails();
        getAllQRWithThumbnail();
        getAllSites();
    }, [])



    const radioButtonValueChange = (e) => {
        if (e.target.value === "hide") {
            setGetRadioButton({
                show: "hide",
                selected: e.target.value,
            });
        } else {
            setGetRadioButton({
                show: "show",
                selected: e.target.value,
            });
        }
    };

    const getDeviceTypeData = () => {
        setLoading(true)
        fetchDeviceProducts()
            .then(response => {
                dispatch(setDeviceTypes(response.data))
            })
            .catch((err) => {
                console.log("Err: ", err);
            })
    }

    const getAreaTypeDetails = () => {
        setLoading(true)
        fetchProducts()
            .then(response => dispatch(setAreaTypes(response.data)))
            .catch((err) => {
                console.log("Err: ", err);
            })
    }

    const getDeviceDetails = (e) => {
        setCurrentDeviceTypeId(e.target.value)
        let deviceDetails = allDeviceTypes.find(x => x.deviceTypeId == e.target.value);
        { deviceDetails && deviceDetails.name ? setDeviceName(deviceDetails.name) : '' }

    }

    const getAreaDetails = (e) => {
        setCurrentAreaTypeId(e.target.value)
        let areaDetails = allAreaTypes.find(x => x.areaTypeId == e.target.value);
        { areaDetails && areaDetails.name ? setAreaName(areaDetails.name) : '' }
    }

    const getGuideDetails = (e) => {
        setCurrentGuideTypeId(e.target.value)
        let guideDetails = allGuideTypes.find(x => x.guideTypeId == e.target.value);
        { guideDetails && guideDetails.name ? setGuideName(guideDetails.name) : '' }
    }

    const getMediaDetails = (e) => {
        if (fileInputRef.current != null) { fileInputRef.current.value = ''; }
        if (InputRef.current != null) { InputRef.current.value = ''; }
        setCurrentMediaTypeId(e.target.value)
        let mediaDetails = allMediaTypes.find(x => x.mediaTypeId == e.target.value);
        if (mediaDetails && mediaDetails.name && mediaDetails.key) {
            setCurrentMediaTypeKey(mediaDetails.key)
        }
        if (e.target.value === "Select Media") {
            setCurrentMediaTypeKey("Select Media")
            setDesc("");
        }

        setUrlMedia("");
        setVideoMedia("");
        setVideoFileName("")
        setShowVideo("");
        setPDFFileName("");
        setSource();
        setPdfMedia("");
        setTextMedia("");
    }

    const getGuideTypeDetails = () => {
        setLoading(true)
        fetchGuideProducts()
            .then(response => dispatch(setGuideTypes(response.data)))
            .catch((err) => {
                console.log("Err: ", err);
            })
    }

    const getMediaTypeDetails = () => {
        setLoading(true)
        fetchMediaData()
            .then(response => dispatch(setMediaTypes(response.data)))
            .catch((err) => {
                console.log("Err: ", err);
            })
    }

    const getAllQRWithThumbnail = () => {

        fetchAllQrCodesWithThumbnail()
            .then(response => {
                dispatch(getQrCodeThumbnail(response.data));

            })
            .catch((err) => {
                console.log("Err: ", err);
            })
    }

    const getAllSites = () => {
        setLoading(true)
        fetchSitesWithParentCompany()
            //  fetchSiteDetails()
            .then(response => {

                if (response.data.success) {
                    setSiteData(response.data.data)
                    const matchedSite = response.data.data.find(site => site.siteId === CurrentLocationId);
                    if (matchedSite) {
                        setCompanyNames(matchedSite.parentCompanyName);
                        setCompanyId(matchedSite.companyId);
                        setSiteName(matchedSite.siteName);
                        setSiteId(matchedSite.siteId);
                    }
                }
            })
            .catch((err) => {
                console.log("Err: ", err);
            })
    }

    const handleCaptureImage = () => {
        setIsCaptureImage(true)
        setMediaFiles([])
        setImgSrcs([])
    }
    const handleUploadImage = () => {
        setIsCaptureImage(false);
        setImgSrcs([])
        setCaptureFiles([])
    }

    const handleChange = (files) => {

        const { pictures } = images.upload;
        setIsCaptureImage(false);
        setImgSrcs([])
        setCaptureFiles([])
        setImages(
            {
                ...images,
                upload: {
                    ...images.upload,
                    pictures: [...pictures, ...files]
                },
            },
            () => {
                console.warn("It was added!");
            }
        );
        if (files.length > 0) {
            setMediaFiles(prevFiles => [...prevFiles, ...files]);

            // Check if we need to update the current image index
            const newIndex = Math.max(currentImageIndex, files.length - 1);
            setCurrentImageIndex(newIndex);
            setCurrentImage(files[newIndex]);
            setDialogOpen(true);
            setError('');
            setMediaTypeSelected(true);
        }
    };

    const handleCropComplete = (imagePromise) => {
        if (cropHandledRef.current) {
            console.warn("⚠️ Crop already handled. Skipping second call.");
            return;
        }
        cropHandledRef.current = true;
        imagePromise.then((croppedBase64) => {
            // ✅ Update preview images and conditionally update mediaFiles
            setImgSrcs((prev) => {
                const newImgSrcs = [...prev, croppedBase64];
                if (!isWebCamClick && mediaFiles.length > 0) {
                    setMediaFiles((prev) => [...newImgSrcs]); // ✅ Only add base64
                }

                return newImgSrcs; // ✅ Return to update imgSrcs state
            });

            // ✅ Handle webcam capture as file
            if (isWebCamClick) {
                const byteString = atob(croppedBase64.split(',')[1]);
                const mimeString = croppedBase64.split(',')[0].split(':')[1].split(';')[0];

                const ab = new ArrayBuffer(byteString.length);
                const ia = new Uint8Array(ab);
                for (let i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }

                const blob = new Blob([ab], { type: mimeString });
                const file = new File([blob], `cropped-image-${Date.now()}.jpg`, { type: mimeString });

                setCaptureFiles((prev) => [...prev, file]);
                setIsWebCamCLick(false);
            }

            setDialogOpen(false);

        });
    };

    const handleRemoveImgClick = () => {
        setImgSrcs((prevImgs) => prevImgs.slice(1));
    }
    const handleCancel = () => {
        if (loading) return;
        setLoading(true);
        // if (!currentImage) return;
        if (!currentImage) {
            setLoading(false);
            return;
        }
        // Convert base64 to File
        const byteString = atob(currentImage.split(',')[1]);
        const mimeString = currentImage.split(',')[0].split(':')[1].split(';')[0];
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([ab], { type: mimeString });
        const file = new File([blob], `captured-image-${Date.now()}.jpg`, { type: mimeString });
        // ✅ Always add base64 preview
        // setImgSrcs((prev) => [...prev, currentImage]);
        //new
        setImgSrcs((prev) => {
            if (prev.includes(currentImage)) return prev;
            return [...prev, currentImage];
        });

        if (isCaptureImage) {
            // ✅ Add file to captureFiles
            setCaptureFiles((prev) => [...prev, file]);
            setLoading(false);
        }
        // ✅ Close dialog
        setDialogOpen(false);

    };

    const handleImages = (data) => {
        setCurrentImage(data);        // Show in crop dialog
        setDialogOpen(true);          // Open cropping
        setIsWebCamCLick(true);
        setMediaTypeSelected(true);  // This is a webcam capture
        setError('');
    };

    const handleFileChange = (event) => {

        setPDFFileName()
        setMediaFiles([])
        setPdfMedia()
        setTextMedia()
        if (event.target.files.length > 0) {
            const file = event.target.files[0];
            const size = file.size / 1024 / 1024;
            const url = URL.createObjectURL(file);
            setShowVideo(url);
            setSource(file.name);
            setVideoMedia(file);
            setVideoFileName(file.name);

            if (file.type == "audio/mpeg") {
                setVideoFormatError(true);
                setLoading(false)
            }
            else {
                setVideoFormatError(false)
                setError('');
                setMediaTypeSelected(true)
                // return;
            }

            if (size > 250) {
                setVideoSizeError(true);
                setLoading(false)
            }
            else {
                setVideoSizeError(false)
                setError('');
                setMediaTypeSelected(true)
                return;
            }
        }
        else {
            setSource();
            setShowVideo();
            setVideoMedia();
            setVideoFileName();
            setPDFFileName();
            setPdfMedia();
            setTextMedia();
            emptyData();


        }
    };


    const urlData = (e) => {
        setMediaFiles([]);
        setUrlMedia(e.target.value)
        var res = e.target.value.match('https?: \/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,}');
        if (res == null) {
            setUrlFormatError(true)
        } else {
            setUrlFormatError(false)
            setMediaTypeSelected(true)
        }
        setError('');
    }
    const selectMedia = (params) => {
        mediaKey = params
        switch (params) {
            case "img":
                return <div className=" mt-3 qrBtn">
                    <div className='d-flex gap-3 align-items-center mb-3 justify-content-center'>
                        <button
                            className='btn btn-primary'
                            onClick={handleCaptureImage}
                        >
                            {t("Capture")}
                        </button>
                        <strong className=''>{t("OR")}</strong>
                        <span
                            onClick={handleUploadImage}
                        >
                            <UploadImage
                                {...images.upload}
                                handleChange={handleChange}
                                mediaTypeSelected={mediaTypeSelected}
                                setMediaTypeSelected={setMediaTypeSelected}
                            />
                        </span>
                    </div>

                    {isCaptureImage ? (
                        <WebcamCapture images={handleImages} />
                    ) : ''

                    }

                    {currentImage && (
                        <ImageCropper
                            open={dialogOpen}
                            image={currentImage}
                            onComplete={handleCropComplete}
                            onCancel={handleCancel}
                            containerStyle={{
                                position: "relative",
                                width: "100%",
                                height: 250,
                                background: "#d3d3d3",
                            }}
                        />
                    )}

                    <div className='img-section m-0 flex-wrap d-flex align-items-center'>
                        {imgSrcs.length > 0 && (
                            <div className="form-group multipal-images mt-3">
                                <ul style={{ display: 'flex', flexWrap: 'wrap', padding: 0, margin: 0, listStyle: 'none' }}>
                                    {imgSrcs.map((imgSrc, index) => (
                                        <li key={index} style={{ marginRight: '5px', position: 'relative' }}>
                                            <button className='btn' onClick={() => handleRemoveImgClick(index)} style={{ position: 'absolute', top: 0, right: 0 }}>
                                                <CloseIcon />
                                            </button>
                                            <span>
                                                <img src={imgSrc} alt={`Cropped Image ${index}`} style={{ width: '100px', height: '100px', objectFit: 'cover' }} />
                                            </span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                    {error ? <small className="text-danger d-block mt-2">{error.imagesErr}</small> : ""}
                </div>;

            case "vdo":
                return <div className="VideoInput ">
                    <input
                        ref={InputRef}
                        className="VideoInput_input mt-2"
                        type="file"
                        onChange={(e) => handleFileChange(e)}
                        accept=".mov,.mp4,.wmv,.avi,.MOV"
                    />
                    {showVideo && showVideo.length > 0 ?

                        <ReactPlayer
                            className="video_react"
                            url={showVideo}
                            width="450px"
                            height="300px"
                            controls={true}
                            playing={false}
                            // onDuration={(duration) => {
                            //     setPlayed(duration);
                            // }}
                            volume={0.5}
                        />

                        : ""}
                    {error ? <small className="text-danger d-block mt-2">{error.video}</small> : ""}
                    {
                        < small className="text-danger d-block mt-2">{!videoFormatError ? ' ' : 'Invalid Format'}</small>
                    }
                    {
                        < small className="text-danger d-block mt-2">{!videoSizeError ? ' ' : 'Size cannot exceed 250 MB'}</small>
                    }
                </div>;

            case "url":
                return <div>

                    <input name="urlMedia" className="form-control mt-2" placeholder="https://example.com"
                        type="text" maxLength={50} onChange={urlData} value={urlMedia}
                    />
                    {error ? <small className="text-danger d-block mt-2">{error.urlMediaErr}</small> : ""}
                    {
                        < small className="text-danger d-block mt-2">{!urlFormatError ? ' ' : 'Invalid URL'}</small>
                    }

                </div>

            case "pdf":
                return <div>
                    <input type="file" name="pdfMedia" className='form-control col-sm-6 mt-2'
                        ref={fileInputRef} accept=".pdf" onChange={(e) => { onPdfSaveData(e) }} />
                    <small className="text-danger d-block mt-2">{pdferror}</small>
                    {error ? <small className="text-danger d-block mt-2">{error.pdfMediaErr}</small> : ""}
                </div>

            case "Text":
                return (
                    <div className="w-100">
                        <div className="w-100">
                            <ReactQuillEditor value={textMedia} // Pass the value to the editor
                                onChangeValue={handleEditorChange} // Handle value change in the parent
                            />
                            {/* )}*/}
                        </div>
                    </div>
                );
            default:
                return <div></div>
        }
    }

    const onPdfSaveData = (e) => {
        setUrlMedia()
        setVideoMedia()
        setVideoFileName('')
        setMediaFiles([])
        setTextMedia("")
        const files = e.target.files[0];
        if (files && files.type == "application/pdf") {

            setPDFFileName(files.name.replace(/ /g, "_"));
            setPdfMedia(files)
            setMediaTypeSelected(true)
        }
        else {
            setPdfError("Only PDFs are valid.")
            return;
        }
        setError('')
        setPdfError('')
        //setPDFFileName("");

    };

    const handleEditorChange = (content, editor) => {
        // const data = editor.getData();
        setTextMedia(content);
        setTextError(Data.trim() === '');
    };

    const handleInputForDropdown = (e) => {
        const QRProductPresent = allQrDataWithThumbnail.filter((item) => item.qRcodeId.toString().startsWith(e) || item.qRcodeId.toString().includes(e))
        QRProductPresent.length > 0 ? setSearchState("Number") : setSearchState("String")
    }
    const confirmUpload = (e) => {
        let result = handleErrors(e);
        return result
    };
    const emptyData = () => {
        if (source) {
            setPDFFileName("");
            setPdfMedia("");
        }

    }
    const handleErrors = (e) => {

        e.preventDefault();
        let err = { ...error }
        if (source == undefined)
            err.video = "Please select video"
        if (mediaFiles == null)
            err.imagesErr = "Please select image"
        if (urlMedia == '')
            err.urlMediaErr = "Please enter url"
        if (pdfMedia == "")
            err.pdfMediaErr = "Please select pdf"

        setError(err)
        if (err.imagesErr != undefined) {
            err.imagesErr = "Please select image"
            return false;
        }


    };
    function b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;
        var byteCharacters = atob(b64Data);
        var byteArrays = [];
        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);
            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }
        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
    const saveMediaData = async (e) => {

        setLoading(true);
        let errResult = confirmUpload(e);
        if (errResult == true || !urlFormatError && !videoFormatError && !textError) {
            let isMedia = false;
            const formData = new FormData();
            if (mediaFiles.length > 0) {
                mediaFiles.forEach((mFile) => {
                    var imageUrl = mFile.split(";");

                    var contentType = imageUrl[0].split(":")[1];
                    var realData = imageUrl[2].split(",")[1];
                    // Convert to blob
                    var blob = b64toBlob(realData, contentType);
                    const _fileData = new File([blob], imageUrl[1].substring(5)); // passing name
                    formData.append("MediaFiles", _fileData);
                    isMedia = true;
                });
            }
            // for source / vedios
            if (source) {
                const vedioData = new File([
                    new Blob([videoMedia])
                ], videoFileName);
                formData.append("MediaFiles", vedioData);
                isMedia = true;
                setVideoMessage(true);
            }
            // for PDF 
            if (pdfMedia) {
                const pdfData = new File([
                    new Blob([pdfMedia])
                ], pdfFileName);
                formData.append("MediaFiles", pdfData);
                isMedia = true;
            }

            if (textMedia) {
                isMedia = false;
            }

            if (captureFiles.length > 0) {
                captureFiles.forEach((file) => {
                    formData.append("MediaFiles", file); // file is already a Blob
                });
                isMedia = true;
            }

            formData.append("MediaData", urlMedia);
            formData.append("locationId", CurrentLocationId);
            formData.append("companyId", companyId || CurrentCompanyId);
            formData.append("qRCode", Id || NewQR || QRCode);
            formData.append("deviceTypeId", currentDeviceTypeId);
            formData.append("areaTypeId", currentAreaTypeId);
            formData.append("guideTypeId", currentGuideTypeId);
            formData.append("mediaTypeId", currentMediaTypeId);
            formData.append("MediaTypeKey", currentMediaTypeKey);
            // formData.append("description", desc);
            formData.append("name", 'abc');
            formData.append("IsMedia", isMedia)
            if (mediaKey != "Text") {
                formData.append("description", desc);
            }
            else {
                formData.append("description", textMedia);
            }
            const response_ = await axios({
                method: 'post',
                url: url.SAVEMEDIA_QRDATA,
                data: formData,
            }).then(response => {
                toast.success(response.data.message, {
                    className: "toastSuccess",
                });
                setLoading(false);
                setVideoMessage(false);
                setUrlMedia("");
                setPdfMedia("");
                setVideoMedia("");
                setSource("");
                setTextMedia("");
                setMediaFiles([])
                setImgSrcs([]);
                setCurrentMediaTypeId("");
                setCurrentMediaTypeKey("");
                setDesc("")
                setCountDesc("");
                setShowVideo("");
                setCaptureFiles([])
                setIsCaptureImage(false)
                setMediaTypeSelected(false)
            })
                .catch((err) => {
                    console.log("Err: ", err);
                });

            setLoading(false);
            setImages({
                upload: {
                    pictures: [],
                    maxFileSize: 53351526,
                    imgExtension: [".jpg", ".png", ".jpeg"],
                    defaultImages: []
                }
            });
            setSource();
            setUrlMedia();
            setPdfMedia();
            setVideoMedia();
            setTextMedia();
            setCaptureFiles([])
            setIsCaptureImage(false)
            setMediaTypeSelected(false)
            // setEditorState("")                       
        }
    };

    const saveMediaType = async (e) => {
        setLoading(true);

        let errResult = confirmUpload(e);
        if (errResult == true || !urlFormatError && !videoFormatError && !textError) {
            // setLoading(false);
            let isMedia = false;
            // setLoading(true);
            const formData = new FormData();
            //setLoading(true);
            if (mediaFiles.length > 0) {
                mediaFiles.forEach((mFile) => {
                    var imageUrl = mFile.split(";");

                    var contentType = imageUrl[0].split(":")[1];
                    var realData = imageUrl[2].split(",")[1];
                    // Convert to blob
                    var blob = b64toBlob(realData, contentType);
                    const _fileData = new File([blob], imageUrl[1].substring(5)); // passing name
                    formData.append("MediaFiles", _fileData);
                    isMedia = true;
                });
            }


            // for source / vedios
            if (source) {
                setMediaFiles([])
                setImages()

                const vedioData = new File([
                    new Blob([videoMedia])
                ], videoFileName);
                formData.append("MediaFiles", vedioData);
                isMedia = true;
                setVideoMessage(true);
            }
            // for PDF 
            if (pdfMedia) {

                setMediaFiles([])
                setImages()
                const pdfData = new File([
                    new Blob([pdfMedia])
                ], pdfFileName);
                formData.append("MediaFiles", pdfData);
                isMedia = true;
            }

            // For TEXT

            if (textMedia) {
                setImages()
                isMedia = false;
            }

            if (captureFiles.length > 0) {
                captureFiles.forEach((file) => {
                    formData.append("MediaFiles", file); // file is already a Blob
                });
                isMedia = true;
            }
            formData.append("MediaData", urlMedia);
            formData.append("locationId", CurrentLocationId);
            formData.append("companyId", companyId || CurrentCompanyId);
            formData.append("qRCode", Id || NewQR || QRCode);
            formData.append("deviceTypeId", currentDeviceTypeId);
            formData.append("areaTypeId", currentAreaTypeId);
            formData.append("guideTypeId", currentGuideTypeId);
            formData.append("mediaTypeId", currentMediaTypeId);
            formData.append("MediaTypeKey", currentMediaTypeKey);
            //formData.append("description", desc);
            formData.append("name", 'abc');
            formData.append("IsMedia", isMedia);

            if (mediaKey != "Text") {
                formData.append("description", desc);
            }
            else {
                formData.append("description", textMedia);
            }
            const response_ = await axios({
                method: 'post',
                url: url.SAVEMEDIA_QRDATA,
                data: formData,
            }).then(response => {

                toast.success(response.data.message, {
                    className: "toastSuccess",
                });
                setLoading(false);
                setVideoMessage(false);
                setUrlMedia("");
                setPdfMedia("");
                setPDFFileName();
                setVideoMedia("");
                setSource("");
                setMediaFiles([])
                setImgSrcs([]);
                setTextMedia("");
                //setEditorState("");
                setCurrentAreaTypeId("");
                setCurrentGuideTypeId("");
                setCurrentMediaTypeId("");
                setCurrentDeviceTypeId("");
                setCurrentMediaTypeKey("");
                setDesc("");
                setCountDesc("");
                setShowVideo("");
                setCaptureFiles([])
                setIsCaptureImage(false)
            })
                .catch((err) => {
                    console.log("Err: ", err);
                });

            setLoading(false);
            setImages({
                upload: {
                    pictures: [],
                    maxFileSize: 5242880,
                    imgExtension: [".jpg", ".png", ".jpeg"],
                    defaultImages: []
                }
            });
            setSource();
            setUrlMedia();
            setPdfMedia();
            setVideoMedia();
            setTextMedia("");
            setCaptureFiles([])
            setIsCaptureImage(false)
            //setEditorState("")          
        }
    };
    const isMediaValid =
        currentDeviceTypeId &&
        currentDeviceTypeId !== "0" &&
        mediaTypeSelected &&
        currentAreaTypeId &&
        currentAreaTypeId !== "Select Area" &&
        currentGuideTypeId &&
        currentGuideTypeId !== "Select Guide" &&
        currentMediaTypeId !== "" &&
        currentMediaTypeId !== "Select Media" &&
        !videoFormatError &&
        !videoSizeError &&
        !urlFormatError;

    const isTextValid = !!textMedia && textMedia.trim() !== "" && !textError;


    const isFormValid = isMediaValid || isTextValid;

    const copyMediaData = () => {

        const formData = new FormData();
        formData.append("secondaryQR", Id || NewQR || QRCode);
        formData.append("primaryQR", copyQRCodeId);
        formData.append("QRCodeID", Id || NewQR || QRCode);
        // formData.append("QRDescription", qrCodeDescription);
        // formData.append("Product_Name", productData);
        copyAllQRDataById(formData).then(response => {
            dispatch(copyQRCodeIdData(formData))
            if (response.data.success) {
                toast.success(response.data.message, {
                    className: "toastSuccess",
                });
                history.push('/PrimarySecondary');
                setCopyQRCodeId("");
                setCompanyName("");
            }
            else {
                toast.error(response.data.message, {
                    className: "toastSuccess",
                });
                // setLoading(false);
            }
        })
            .catch((err) => {
                console.log("Err: ", err);
            });
    }

    const handleClearStates = () => {
        setNewQR("")
        setIsSiteCompanyShow(false)
        setqrcode("")
        setValidQrError("")
        SetIsUploadPageShow(false)
        setLocationIdByQRId(1)
    }
    return (
        <section className='detail-code text-left'>
            <Toaster />
            {loading ? <Loader /> : ''}
            <div className='inner-head'>
                <h4>{t("QRDetails")}</h4>
            </div>
            <div className='form-box'>
                <ul className='list-box'>
                    {/* <li><label>Site :</label> <span>{LocationName}</span></li>
                     */}
                    <li><label>{t("SiteLabel")}</label> <span>{SiteName ? SiteName : siteName} </span></li>
                    <li><label>{t("CompanyLabel")}</label> <span>{companyName}</span></li>
                    <li><label>{t("QRCodeIDLabel")}</label> <span>{Id || QRCode || NewQR}</span></li>
                </ul>
                <ul className="radio-box">
                    <li>
                        <input
                            type="radio"
                            value="show"
                            name="content"
                            id="show"
                            onClick={radioButtonValueChange}
                            checked={getRadioButton.selected === "show"}
                        />
                        <label className="m-0" for="show">{t("UploadMedia")}</label>
                    </li>
                    <li>
                        <input
                            type="radio"
                            value="hide"
                            name="content"
                            id="hide"
                            onClick={radioButtonValueChange}
                            checked={getRadioButton.selected === "hide"}
                        />
                        <label className="m-0" for="show">{t("LinkToPrimaryQR")}</label>
                    </li>
                </ul>
                {getRadioButton.show == "hide" ? (
                    <div className="assign-media mt-4 row">
                        <div className="col-sm-5">
                            <div class="form-group m-0">
                                <label>{t("SelectPrimaryQR")} </label>
                                <div class=" d-flex qr-img-select qrTable--select mapping wkmapping ">
                                    <Select
                                        class="form-select mb-0 flex-grow-1 filter-select"
                                        aria-label=".form-select-lg example"
                                        showSearch
                                        value={copyQRCodeId}
                                        style={{ width: 650 }}
                                        onChange={(e) => {
                                            var productFound = allQrDataWithThumbnail.filter((item) => item.product_Name == e)
                                            if (productFound.length > 0) {
                                                setCopyQRCodeId(productFound[0].qRcodeId);
                                            }
                                            else {
                                                setCopyQRCodeId(e);
                                            }
                                        }}
                                        onSearch={(e) => {
                                            handleInputForDropdown(e)
                                        }}
                                    >
                                        <Option value="0">{t("SelectQRPlaceholder")} </Option>
                                        {allQrDataWithThumbnail &&
                                            allQrDataWithThumbnail.map((QRCode, k) =>

                                                <Option
                                                    key={QRCode.qRcodeId}
                                                    value={searchState === "Number" || QRCode.product_Name == null ? QRCode.qRcodeId : QRCode.product_Name}
                                                >
                                                    <div className="d-flex gap20 align-items-center">
                                                        <div className="avatar-img">
                                                            {QRCode.filename ?
                                                                <>
                                                                    < img className="img-mapping" src={QRCode.filename}></img>{QRCode.favorites == true ? <img className="favorite_star" src={favoriteIcon}></img> : ""}
                                                                </>
                                                                :
                                                                <>
                                                                    < img className="img-mapping" src={LoginImage}></img>{QRCode.favorites == true ? <img className="favorite_star" src={favoriteIcon}></img> : ""}
                                                                </>}
                                                        </div>
                                                        <div className="qrDesc content d-flex">
                                                            {QRCode.product_Name ? <Tooltip title={QRCode.product_Name}>
                                                                <h6>{QRCode.product_Name}</h6>
                                                            </Tooltip>
                                                                : <h6>- NA - </h6>}
                                                            <p>{QRCode.qRcodeId}</p>
                                                            <Tooltip title={QRCode.qR_Description}>
                                                                <p>{QRCode.qR_Description}</p>
                                                            </Tooltip>
                                                        </div>
                                                    </div>
                                                </Option>

                                            )}
                                    </Select>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12 d-flex align-items-end mt-3">

                            {Id && copyQRCodeId && copyQRCodeId != "Select QR" ?
                                <button

                                    className="btn btn-primary mt20 "
                                    onClick={() => copyMediaData()}
                                >
                                    {t("LinkAndSave")}
                                </button> : <button

                                    className="btn btn-primary mt20"
                                    onClick={() => copyMediaData()} disabled
                                >
                                    {t("LinkAndSave")}
                                </button>
                            }
                        </div>
                    </div>
                ) : ""}
                {getRadioButton.show == "show" &&
                    <Row className='form-box row-gap-3 p-0'>
                        <Col lg={6}>
                            <div className="form-group">
                                <label>{t("SelectDeviceType")} <sup className='text-danger'>*</sup> </label>
                                <div className="input-group">
                                    <div class="input-group">
                                        <select className="form-select mb-0  filter-select" aria-label=".form-select-lg example" value={currentDeviceTypeId}
                                            onChange={(e) => getDeviceDetails(e)
                                            }>
                                            <option value="0">{t("SelectDevice")}</option>
                                            {
                                                allDeviceTypes && allDeviceTypes.map(deviceTypes =>
                                                    !deviceTypes.isDeleted && deviceTypes.active && (
                                                        <option key={deviceTypes.deviceTypeId} value={deviceTypes.deviceTypeId}>
                                                            {deviceTypes.name}
                                                        </option>
                                                    )
                                                )
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div className="form-group">
                                <label>{t("SelectAreaType")}<sup className='text-danger'>*</sup> </label>
                                <div className="input-group">
                                    <div class="input-group">
                                        <select className="form-select mb-0  filter-select" aria-label=".form-select-lg example" value={currentAreaTypeId}
                                            onChange={(e) => getAreaDetails(e)
                                            }>
                                            <option selected="">{t("SelectArea")}</option>
                                            {
                                                allAreaTypes && allAreaTypes.map(areaTypes =>
                                                    !areaTypes.isDeleted && areaTypes.active && (
                                                        <option key={areaTypes.areaTypeId} value={areaTypes.areaTypeId}>
                                                            {areaTypes.name}
                                                        </option>
                                                    )
                                                )
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div className="form-group">
                                <label>{t("SelectGuideType")} <sup className='text-danger'>*</sup> </label>
                                <div className="input-group">
                                    <div class="input-group">
                                        <select className="form-select mb-0  filter-select" aria-label=".form-select-lg example" value={currentGuideTypeId}
                                            onChange={(e) => getGuideDetails(e)
                                            }>
                                            <option selected="">{t("SelectGuide")}</option>
                                            {
                                                allGuideTypes && allGuideTypes.map(guideTypes =>
                                                    !guideTypes.isDeleted && guideTypes.active && (
                                                        <option key={guideTypes.guideTypeId} value={guideTypes.guideTypeId}>
                                                            {guideTypes.name}
                                                        </option>
                                                    )
                                                )
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div className="form-group">
                                <label>{t("SelectMediaType")} <sup className='text-danger'>*</sup> </label>
                                <div className="input-group">
                                    <div class="input-group">
                                        <select className="form-select mb-0  filter-select" aria-label=".form-select-lg example" value={currentMediaTypeId}
                                            onChange={(e) => {

                                                setCurrentMediaTypeId(e.target.value === "Select Media" ? 0 : e.target.value);
                                                getMediaDetails(e);
                                            }
                                            }>
                                            <option selected="">{t("SelectMedia")}</option>
                                            {
                                                allMediaTypes && allMediaTypes.map(mediaTypes =>
                                                    <option key={mediaTypes.mediaTypeId} value={mediaTypes.mediaTypeId}>

                                                        {mediaTypes.name}
                                                    </option>,
                                                )
                                            }
                                        </select>
                                    </div>
                                </div>
                                {currentMediaTypeKey != null && currentMediaTypeId != "Select Media" ? <div>{selectMedia(currentMediaTypeKey)}</div> : ''}
                            </div>
                        </Col>
                        {/* <Col lg={6}>
                                <div className="form-group">
                                    <label>Company Name </label>
                                    <div className="input-group">
                                        <input name="" className="form-control" placeholder="Enter Name" type="text" />
                                    </div>
                                </div>
                            </Col>*/}

                        {/* <Col lg={6} className="d-flex">
                                <div className='d-flex gap-3 form-group mt-auto w-100'>
                                    <button className='btn btn-bordered w-100'>Capture Image</button>
                                    <button className="btn btn-bordered w-100">Upload Image</button>
                                </div>
                            </Col> */}
                        {mediaKey != "Text" ?
                            <Col lg={12}>
                                <div className="form-group">
                                    <label>{t("AddDescription")} </label>
                                    <div className="input-group">
                                        <textarea name="" className="form-control" placeholder={t("EnterDescriptionHere")} type="text" value={desc} onChange={(e) => { setDesc(e.target.value), setCountDesc(e.target.value.length) }} rows={6}></textarea>
                                        <span className="w-100 text-right fs12">{countDesc}/1000</span>
                                    </div>
                                </div>
                            </Col> : ''}

                        <div className='d-flex gap-3 justify-content-end flex-wrap'>
                            <Button className='btn btn-bordered' onClick={() => {
                                if (isUploadPageShow) {

                                    handleClearStates()
                                }

                                else {
                                    SetIsUploadMediaShow(false)
                                }
                            }}>{t("Back")}</Button>
                            <Button onClick={saveMediaType} disabled={!isFormValid}>{t("SaveAndNew")}</Button>
                            <Button onClick={saveMediaData} disabled={!isFormValid}>{t("Save")}</Button>

                        </div>

                    </Row>
                }


            </div>
        </section >
    )
}
export default UploadMedia